import { AgGridModule } from '@ag-grid-community/angular';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { MaterialModule } from 'app/main/material.module';
import { PlanComponent } from 'app/main/plan/plan.component';
import {
    KeyValueCellRendererComponent
} from 'app/main/shared/key-value-cell-renderer/key-value-cell-renderer.component';
import { MomentModule } from 'ngx-moment';

import { PlanEffects } from './plan.effects';
import * as fromPlan from './plan.reducer';
import { PlanResolver } from './plan.resolver';

@NgModule({
    declarations: [
        PlanComponent,
    ],
    imports     : [
        FuseSharedModule,
        MaterialModule,

        // AG Grid
        AgGridModule.withComponents([KeyValueCellRendererComponent]),

        PageTitleModule,
        MomentModule,
        StoreModule.forFeature('plan', fromPlan.reducer),
        EffectsModule.forFeature([PlanEffects]),
    ],
    exports     : [
        PlanComponent,
    ],
    providers: [
        PlanResolver
    ]
})

export class PlanModule
{
}
